var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 6.00003C20.6363 6.28613 20.8632 6.62603 21.0177 7.00016C21.1722 7.37429 21.2511 7.77527 21.25 8.18003V18.18C21.25 18.9978 20.9258 19.7823 20.3485 20.3615C19.7712 20.9407 18.9878 21.2674 18.17 21.27H5.83C5.0113 21.2647 4.22793 20.9358 3.65089 20.355C3.07384 19.7742 2.74998 18.9887 2.75 18.17V5.85003C2.75 5.03316 3.0745 4.24975 3.65211 3.67214C4.22972 3.09453 5.01313 2.77003 5.83 2.77003H15.83C16.2348 2.76893 16.6357 2.84788 17.0099 3.00234C17.384 3.1568 17.7239 3.38371 18.01 3.67003L20.35 6.00003Z",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8901 14.05H16.1101C16.6538 14.05 17.1752 14.2659 17.5597 14.6504C17.9441 15.0348 18.1601 15.5563 18.1601 16.1V21.24H5.8301V16.11C5.82878 15.8391 5.88116 15.5706 5.98421 15.3201C6.08727 15.0695 6.23896 14.8419 6.43051 14.6504C6.62206 14.4588 6.84968 14.3071 7.10021 14.2041C7.35074 14.101 7.61921 14.0486 7.8901 14.05V14.05Z",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83008 2.76001V7.18001C5.83008 7.64149 6.0134 8.08406 6.33971 8.41038C6.66603 8.73669 7.1086 8.92001 7.57008 8.92001H14.3701C14.8316 8.92001 15.2741 8.73669 15.6004 8.41038C15.9268 8.08406 16.1101 7.64149 16.1101 7.18001V2.86001",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0293 5.32007V6.35007",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.7a3f61ccf4ede091cdd68663e7d29c28.svg";
export { ForwardRef as ReactComponent };